<script setup lang="ts">
defineProps<{
  collapsed?: boolean
}>()
</script>

<template>
  <NuxtLink to="/" class="flex items-center gap-3 group shrink-0">
    <div class="size-10 rounded-full bg-surface border border-primary/30 flex items-center justify-center overflow-hidden group-hover:border-primary transition-colors duration-300 shadow-[0_0_10px_rgba(232,205,154,0.2)]">
      <img alt="Panda Logo" class="size-full object-cover" src="/logo.webp" />
    </div>
    <div v-if="!collapsed" class="flex flex-col">
      <span class="font-display font-bold text-2xl tracking-wider text-toned group-hover:text-highlighted transition-colors">PANDAAHH</span>
      <span class="text-[10px] text-primary/80 font-bold uppercase tracking-widest -mt-1">RIVEN BOT ADMIN</span>
    </div>
  </NuxtLink>
</template>
